import { getPdfSizes } from "helpers";
import jsPDF from "jspdf";
import moment from "moment";

import { Driver } from "../../drivers.types";

interface renderTitlesProps {
  pdf: jsPDF;
  bigFontSize: number;
  normalFontSize: number;
  driver: Driver;
  date: string;
}

export const renderTitles = ({
  pdf,
  bigFontSize,
  normalFontSize,
  driver,
  date
}: renderTitlesProps) => {
  const { pageWidth } = getPdfSizes(pdf);

  pdf
    .setFontSize(bigFontSize)
    .setFont("helvetica", "normal", "bold")
    .text("Contact Information", pageWidth / 2, 36, {
      align: "center"
    });

  pdf.setFontSize(normalFontSize);
  pdf.text(`${driver.firstname} ${driver.lastname}`, pageWidth / 2, 51, {
    align: "center"
  });

  pdf.text(
    `List updated at: ${moment(date).format("DD MMMM, YYYY")}`,
    pageWidth / 2,
    64,
    {
      align: "center"
    }
  );
};
